import Rollbar from 'rollbar';

/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Hazards-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 2/23/18
 * Copyright All Rights Reserved
 */

const rollbarInit = (enabled, environment, accessToken) => {
  const rollbarConfig = {
    accessToken,
    captureUncaught: true,
    enabled,
    payload: {
      environment,
    },
  };
  return Rollbar.init(rollbarConfig);
};

export default rollbarInit;
